import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  fill: "none",
  viewBox: "0 0 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.8 0 16 4.118h-2.4V14H12V4.118H9.6zm-4 12.353V14H0v-1.647zm0-5.765v1.647H0V6.588zM7.2.824V2.47H0V.824z"
    }, null, -1)
  ])))
}
export default { render: render }